import React, { Fragment, useEffect, useState } from 'react'
import { useCart } from 'medusa-react'
import { useFeaturedProductsQuery } from '@lib/hooks/use-layout-data'
import { mapToMicrodataPixel } from '@lib/util/map-microdata-pixel'
import { MicrodataItem } from '@common/interface/meta-pixel'
import { listBrandsByCollectionId } from '@lib/util/brand-handler'
import { useQuery } from '@tanstack/react-query'
import { IProduct } from '@common/interface/product'

interface PropsType {
  item: IProduct
}

const MicodataItemTag = ({ microdata }: { microdata: MicrodataItem }) => {
  return (
    <Fragment>
      <meta property="og:title" content={microdata.title} />
      <meta
        property="og:description"
        content={microdata.description ?? 'Product description'}
      />
      <meta property="og:url" content={microdata.url} />
      <meta property="og:image" content={microdata.image} />
      <meta property="og:price:amount" content={microdata.price} />
      <meta
        property="og:price:currency"
        content={microdata.currency ?? 'sgd'}
      />
      <meta property="product:availability" content={microdata.availability} />
      <meta property="product:price:amount" content={microdata.price} />
      <meta
        property="product:price:currency"
        content={microdata.currency ?? 'sgd'}
      />
      <meta property="product:retailer_item_id" content={microdata.sku} />
      <meta property="product:brand" content={microdata.brand} />
      <meta property="product:condition" content={microdata.condition} />
    </Fragment>
  )
}

const MetaPixelMicrodataTag = ({ item }: PropsType) => {
  const { cart } = useCart()
  const { data } = useFeaturedProductsQuery({ id: [item.id] })
  const [microdatas, setMicodatas] = useState<MicrodataItem[]>([])

  const { data: brands } = useQuery(['brands', item], () =>
    listBrandsByCollectionId(item?.collection_id ?? '')
  )

  useEffect(() => {
    if (cart != null && data != null && data.products?.length > 0) {
      const microdatas = mapToMicrodataPixel(
        cart as any,
        data?.products[0],
        brands
      )
      setMicodatas([...microdatas])
    }
  }, [cart, data, brands])

  return (
    <>
      {microdatas.map((m, k) => {
        return <MicodataItemTag microdata={m} key={k} />
      })}
    </>
  )
}

export default MetaPixelMicrodataTag
